import React from "react";
import TextButton from "../../../templates/component/buttons/textButton";

const AboutAddButton = () =>{

    return(
        <>
            <TextButton />

        </>
    )
}

export default AboutAddButton;